import { defineStore } from 'pinia'
import { currentCredentials } from '@/services/aws-amplify-service'

export const useUserStore = defineStore('user-store', {
  state: () => ({
    error: null,
    loggedInUser: null,
    hasToken: null,
    lastCheckedTokenIsExpiredDate: Date.now()
  }),
  getters: {
    getError: (state) => {
      return state.error
    },
    getLoggedInUser: (state) => {
      return state.loggedInUser
    },
    getHasToken: (state) => {
      return state.hasToken
    },
    getToken: (state) => {
      return state.loggedInUser?.session?.idToken
    },
    getTimeLeftBeforeTokenRefresh: (state) => {
      const token = state.loggedInUser?.session?.idToken
      if (!token) {
        return 0
      } else {
        const expiry = token.payload.exp
        const currentTime = Math.floor(
          state.lastCheckedTokenIsExpiredDate / 1000
        )
        return expiry - currentTime
      }
    },
    getTokenIsExpired() {
      return this.getTimeLeftBeforeTokenRefresh <= 0 // cannot use 'this' if arrow function
    },
    getUserInfo: (state) => {
      const user = state.loggedInUser
      if (user && user.session && user.session.idToken) {
        const info = user.session.idToken.payload
        const groups = info['cognito:groups'] || []
        let groupName = 'My Group'
        if (groups.length === 1) {
          groupName = groups[0]
        }
        return {
          username: info.pulsUsername || info['cognito:username'],
          organizationName: info.organizationName,
          organizationFullName: info.organizationFullName,
          organizationLogoUrl: info.organizationLogoUrl,
          groupName: groupName,
          givenName: info.given_name ? info.given_name : info.email,
          groups,
          fullName:
            info.given_name && info.family_name
              ? `${info.given_name} ${info.family_name}`
              : info.email
        }
      }
      return {}
    },
    getOrgConfig: () => {
      // This is the ONLY place in the app where we parse localStorage.orgData
      try {
        return JSON.parse(localStorage.orgData || {})
      } catch (_) {
        return {}
      }
    },
    getLastAuthUser() {
      const orgConfig = this.getOrgConfig
      const userPoolWebClientId = orgConfig.userPoolWebClientId
      if (userPoolWebClientId) {
        const key = `CognitoIdentityServiceProvider.${userPoolWebClientId}.LastAuthUser`
        return localStorage.getItem(key)
      } else {
        return null
      }
    },
    userIsGroupAdmin: (state) => {
      return state.loggedInUser?.session?.idToken.payload.userIsAdmin === 'true'
    },
    userIsPulsAdmin: (state) => {
      return (
        state.loggedInUser?.session?.idToken.payload.userIsPulsAdmin === 'true'
      )
    },
    userIsAnyAdmin: (state) => {
      const payload = state.loggedInUser?.session?.idToken.payload || {}
      return (
        payload.userIsAdmin === 'true' || payload.userIsPulsAdmin === 'true'
      )
    }
  },
  actions: {
    updateTokenIsExpired() {
      this.lastCheckedTokenIsExpiredDate = Date.now()
    },
    async checkAuthentication() {
      this.error = null
      return currentCredentials()
        .then((user) => {
          this.loggedInUser = user
          this.hasToken = true
        })
        .catch((error) => {
          this.error = { name: error.name, message: error.message }
          console.error(error)
          // console.error('checkAuthentication error', error)
          throw error
        })
    },
    setLoggedInUser(loggedInUser) {
      this.loggedInUser = loggedInUser
    },
    setHasToken(hasToken) {
      this.hasToken = hasToken
    }
  }
})
